import React from 'react';
import {
  Empty,
  SpinProps,
  Table,
  TableProps,
  // PaginationProps as AntdPaginationProps,
} from 'antd';

import {
  StyledAntdTable,
} from './style';
import Spinner from '../Spinner';

const TypedStyledAntdTable = StyledAntdTable();

// const CVTable = <T extends Record<string, unknown> = Record<string, never>>(
// eslint-disable-next-line
const CVTable = <T extends object = Record<string, never>>(
  props: TableProps<T>,
): JSX.Element => {
  const { loading, locale, pagination } = props;
  const loadingProp: boolean | SpinProps | undefined = typeof loading === 'boolean' ? {
    spinning: loading,
    indicator: <Spinner />,
  } : loading;

  const finalPagination = pagination !== undefined ? pagination : {
    defaultPageSize: 20, // TODO: Maybe get this from a single source of truth
  };

  return (
    <TypedStyledAntdTable
      {...props}
      pagination={finalPagination}
      locale={{
        ...locale,
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Vazio" />,
      }}
      loading={loadingProp}
    />
  );
};

CVTable.Column = Table.Column;
CVTable.ColumnGroup = Table.ColumnGroup;

export default CVTable;
